import React, { useEffect, useState, Fragment, useRef } from "react";
import { Link } from "react-router-dom";
import MainContent from "../../../layouts/maincontent/MainContent";
import InputElement from "../../../shared/form/InputElement";

import styleProfile from "./Profile.module.css";
import {
  checkNationalId,
  getUser,
  checkVerifications,
  profileVerificationEmail,
  profileVerificationPhone,
  uploadImages,
} from "../../../adapters/apis/auth/auth";

import { edit_profile } from "../../../adapters/apis/auth/auth";
import useFileHandler from "../../../hooks/useFileHandler";
import { useNavigate, useLocation } from "react-router-dom";
import AttachmentName from "../../../helpers/AttachmentName";

import Modal from "react-modal";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { validateEgyptianPhoneNumberWithPhoneInput } from "../../../helpers/Validation";

function Profile({ response: propResponse }) {
  Modal.setAppElement("body");
  const { state } = useLocation();
  const query = new URLSearchParams(useLocation().search);
  const queryResponse = query.get("message");
  const queryClass = query.get("class");
  const queryModal = query.get("modal");

  // const initialResponse =
  //   propResponse ??
  //   state?.response ??
  //   (queryResponse && { message: queryResponse, class: queryClass });

  // const [response, setResponse] = useState(initialResponse);

  const [response, setResponse] = useState(
    propResponse ??
      state?.response ??
      (queryResponse && {
        message: queryResponse,
        class: queryClass,
        modal: queryModal,
      }),
  );

  useEffect(() => {
    const newResponse =
      propResponse ??
      state?.response ??
      (queryResponse && {
        message: queryResponse,
        class: queryClass,
        modal: queryModal,
      });
    setResponse(newResponse);
    if (newResponse?.modal && newResponse?.message) {
      setShowModalExpirationMail(true);
      setModalMessageExpirationMail(newResponse?.message);
    }
  }, [propResponse, state, queryResponse, queryClass, queryModal]);

  const navigate = useNavigate();
  const { handlePreviewClick } = useFileHandler();
  const user_data = {
    id: "",
    profile_id: "",
    first_name: "",
    second_name: "",
    third_name: "",
    fourth_name: "",
    email: "",
    phone_number: "",
    nationality: {
      key: "",
      value: "",
    },
    national_id: "",
    passport_number: "",
    passport_num_file: "",
  };

  const [user, setUser] = useState({
    ...user_data,
    // nationality: { key: "EG", value: "مصر" },
  });

  const [error_user, setUserError] = useState({
    ...user_data,
    nationality: "",
  });
  const [disabled, setDisabled] = useState(true);
  const [govs, setGovs] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [villages, setVillages] = useState([]);
  const [streets, setStreets] = useState([]);
  const [success, setSuccess] = useState(false);
  const [verificationID, setVerificationID] = useState([]);
  const [verificationPhoneNumber, setVerificationPhoneNumber] = useState([]);
  const [verificationEmail, setVerificationEmail] = useState([]);
  const [verificationForeign, setVerificationForeign] = useState([]);
  const [verifications, setVerifications] = useState({
    phone_verified: true,
    ocr_verified: true,
    email_verified: true,
  });
  const [errMessageOCR, setErrMessageOCR] = React.useState("");
  const [errMessagePhone, setErrMessagePhone] = React.useState("");
  const [errMessageEmail, setErrMessageEmail] = React.useState("");
  const [isEditMode, setIsEditMode] = useState(true);
  const [loading, setLoading] = React.useState(false);
  const [docUploaded, setDocUploaded] = useState(false);
  const [fileDeleted, setFileDeleted] = useState(false);
  const [errors, setErrors] = useState([]);
  // const [user, setUser] = useState();

  const nationalIdFileInputRef = useRef({});
  const passportFileInputRef = useRef({});
  const [inputKeys, setInputKeys] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [showModalExpirationMail, setShowModalExpirationMail] = useState(false);
  const [modalMessageExpirationMail, setModalMessageExpirationMail] =
    useState("");
  const [natianalErrorMsg, setnatianalErrorMsg] = useState("");
  const [phoneError, setPhoneError] = useState(null);

  useEffect(() => {
    // setResponse(null);
    getUser()
      .then((res) => {
        const userData = res?.data?.data;
        setUser({
          id: userData?.id,
          profile_id: userData?.profile?.id,
          first_name: userData?.profile?.first_name,
          email: userData?.email,
          phone_number: userData?.profile?.mobile,
          country_code: userData?.profile?.country_code,
          dial_code: userData?.profile?.dial_code,
          nationality: {
            key: userData?.profile?.nationality.code,
            value: userData?.profile?.nationality.name,
          },
          national_id: userData?.profile?.national_id,
          passport_number: userData?.profile?.passport_num,
          ocr_verified: userData?.profile?.ocr_verified,
          national_id_file: userData?.profile?.national_id_file
            ? userData?.profile?.national_id_file[0]
            : null,
          passport_num_file: userData?.profile?.passport_num_file
            ? userData?.profile?.passport_num_file[0]
            : null,
          birth_date: userData?.profile?.birth_date,
          birth_place: userData?.profile?.birth_place,
          gender: userData?.profile?.gender,
          restOfName: userData?.profile?.restOfName,
          last_name: userData?.profile?.last_name,
          profile: userData?.profile,
          mobile_verified_at: userData?.profile?.mobile_verified_at,
          email_verified_at: userData?.email_verified_at,
        });
      })
      .catch((err) => {});
    checkVerifications()
      .then((res) => {
        setVerifications(res?.data);
      })
      .catch((err) => {});

    window.history.replaceState({}, document.title, window.location.pathname);
    if (response?.modal && response?.message) {
      setShowModalExpirationMail(true);
      setModalMessageExpirationMail(response?.message);
      setResponse("");
    }
  }, [response]);

  const ocrStatus = parseInt(user?.ocr_verified);
  const ocrStatusText = {
    0: { text: "لم يتم التحقق من الهوية", className: "text-danger" },
    1: { text: "تم التحقق من الهوية", className: "text-success" },
    2: { text: "جاري التحقق من الهوية", className: "text-info" },
  }[ocrStatus];

  const renderOcrStatus = () =>
    ocrStatusText ? (
      <span
        className={`d-inline-block fw-bold ${ocrStatusText.className}`}
        style={{ marginInlineStart: "28px" }}
      >
        {ocrStatusText.text}
      </span>
    ) : null;

  const mobileStatusText = user?.mobile_verified_at
    ? { text: "تم التحقق", className: "text-success" }
    : { text: "لم يتم التحقق", className: "text-danger" };
  const emailStatusText = user?.email_verified_at
    ? { text: "تم التحقق", className: "text-success" }
    : { text: "لم يتم التحقق", className: "text-danger" };

  const renderMobileStatus = () => (
    <span
      className={`d-inline-block fw-bold ${mobileStatusText.className}`}
      style={{ marginInlineStart: "28px" }}
    >
      {mobileStatusText.text}
    </span>
  );

  const renderEmailStatus = () => (
    <span
      className={`d-inline-block fw-bold ${emailStatusText.className}`}
      style={{ marginInlineStart: "28px" }}
    >
      {emailStatusText.text}
    </span>
  );
  const attachments = [
    {
      key: "national_id_file",
      file: user?.national_id_file,
    },
    {
      key: "passport_num_file",
      file: user?.passport_num_file,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  function handleCheckNationalId() {
    setResponse(null);
    setLoading(true);
    setUserError(false);
    checkNationalId()
      .then((res) => {
        if (res?.data?.status == 422) {
          setShowModal(true);
          setModalMessage(res?.data?.message);
          setLoading(false);
        } else if (res?.data?.status == 200) {
          checkVerifications()
            .then((res) => {
              setVerifications(res.data);
            })
            .catch((err) => {});
          const params = new URLSearchParams({
            message: res?.data?.message,
            class: "alert-primary",
          });
          navigate(`/profile?${params.toString()}`);
          setLoading(false);
        }
      })
      .catch((err) => {
        setSuccess(err);
        setLoading(false);
      });
  }

  function handleCheckPhoneNumber() {
    setResponse(null);
    setLoading(true);
    setUserError(false);
    profileVerificationPhone({ mobile: user.phone_number })
      .then((res) => {
        if (res?.data?.responseCode == 429) {
          setErrMessagePhone(res?.data?.message);
          setModalMessage(res?.data?.message);
          setShowModal(true);
          setLoading(false);
        } else {
          localStorage.setItem("context", res?.data?.data?.context);
          localStorage.setItem("mobile", res?.data?.data?.mobile);
          localStorage.setItem("request_code", res?.data?.data?.request_code);
          navigate(
            `/confirm-otp-profile-verification?token=${encodeURIComponent(res?.data?.data?.request_code)}&context=${encodeURIComponent(res?.data?.data?.context)}`,
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        setErrMessagePhone(error?.response?.data?.message);
        setLoading(false);
      });
  }
  function handleCheckEmail() {
    setResponse(null);
    setErrMessageEmail("");
    setLoading(true);
    setUserError(false);
    profileVerificationEmail({ email: user.email })
      .then((res) => {
        if (res?.data?.status == 422) {
          setErrMessageEmail(res?.data?.message);
          setModalMessage(res?.data?.message);
          setShowModal(true);
        } else {
          navigate(`/mail-verify-profile?email=${user.email}`);
        }
        setLoading(false);
      })
      .catch((error) => {
        setErrMessageEmail(
          error?.response?.data?.message || "حدث خطأ أثناء إرسال البريد",
        );
        setLoading(false);
      });
  }

  function handleChange(key, value) {
    setResponse(null);
    setUserError(false);
    setUser((prev) => ({
      ...prev,
      [key]: value,
    }));
    if (value instanceof File) {
      if (key === "national_id_file" || key === "passport_num_file") {
        uploadDocument(value, key);
      }
    }
  }
  const uploadDocument = async (file, fieldName) => {
    setResponse(null);
    setLoading(true);
    setUserError(false);
    setErrors(null);
    const data = new FormData();
    data.append("file", file);
    data.append("label", "profile_attachments");
    uploadImages(data)
      .then((res) => {
        setDocUploaded(true);
        setFileDeleted(false);
        setUser((prev) => ({
          ...prev,
          //[`${fieldName}_path`]: res?.data?.data?.path,
          //[`${fieldName}_url`]: res?.data?.data?.full_url,
          [`${fieldName}_original_file_name`]:
            res?.data?.data?.original_file_name,
        }));
        setError(fieldName, "");
        setLoading(false);
      })
      .catch((error) => {
        setDocUploaded(false);
        setFileDeleted(true);
        setUser((prev) => ({ ...prev, [fieldName]: null }));
        const errorField =
          user?.nationality?.key !== "EG"
            ? "passport_num_file"
            : "national_id_file";

        if (error?.response?.status === 422) {
          setErrors({ [errorField]: error?.response?.data?.errors?.file });
        } else {
          setErrors({ [errorField]: "حدث خطأ أثناء رفع الملف" });
        }
        // setLoading(false);
      });
  };

  const validatePhoneBeforeSubmit = () => {
    const value = user?.phone_number;
    const dialCode = user?.dial_code;
    const countryCode = user?.country_code;
    const nationalNumber = value?.replace(dialCode, "")?.replace(/\D/g, "");
    if (
      value === dialCode ||
      value === "" ||
      value === null ||
      value === undefined
    ) {
      setPhoneError("يجب ادخال رقم الهاتف المحمول");
      return false;
    }

    if (
      user?.nationality?.key == "EG" &&
      !validateEgyptianPhoneNumberWithPhoneInput(value)
    ) {
      setPhoneError(
        "رقم الهاتف المدخل يجب أن يكون رقم هاتف محمول مصريًا صالحًا. يُرجى اختيار مفتاح الدولة (+20) وإدخال رقم هاتف مصري صحيح",
      );
      return false;
    }

    // Egypt-specific rules
    if (countryCode === "eg") {
      const regex = /^(?:0?)(10|11|12|15)\d{8}$/;
      if (!regex.test(nationalNumber)) {
        setPhoneError(
          "رقم الهاتف المدخل يجب أن يكون رقم هاتف محمول مصريًا صالحًا. يُرجى اختيار مفتاح الدولة (+20) وإدخال رقم هاتف مصري صحيح",
        );
        return false;
      }
    }

    // General validation for other countries
    if (!isValidPhoneNumber("+" + value)) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    // Length rule (≤15 digits excluding country code)
    if (nationalNumber?.length < 6 || nationalNumber?.length > 15) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    setPhoneError(null);
    return true;
  };

  function setError(key, value) {
    setResponse(null);
    setUserError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  function changeProfile() {
    setUserError(false);
    setIsEditMode(false);
    setSuccess(false);
    setResponse(null);
  }

  const fieldTranslations = {
    first_name: "الإسم الأول",
    last_name: "باقي الإسم",
    national_id: "الرقم القومي",
    national_id_file: "مرفق الرقم القومي",
    passport_num: "رقم جواز السفر",
    mobile: "رقم الهاتف المحمول",
    passport_num_file: "مرفق جواز السفر",
    email: "البريد الإلكتروني",
    error: "خطأ",
  };

  function updateProfile() {
    setLoading(true);
    setSuccess(false);
    setErrors(false);
    setUserError(false);
    setResponse(null);
    const data = new FormData();
    data.append("email", user?.email);
    data.append("mobile", user?.phone_number);
    data.append("country_code", user?.country_code);
    data.append("dial_code", user?.dial_code);
    data.append("doc_uploaded", docUploaded);
    data.append("doc_deleted", fileDeleted);
    data.append("nationality_code", user?.nationality?.key);
    if (user?.nationality?.key == "EG" && docUploaded) {
      data.append("national_id", user?.national_id);
      data.append("national_id_file", user?.national_id_file);
    } else if (user?.nationality?.key == "EG" && !docUploaded) {
      data.append("national_id", user?.national_id);
      data.append("national_id_file", null);
    } else if (user?.nationality?.key != "EG" && docUploaded) {
      data.append("passport_num", user?.passport_number);
      data.append("passport_num_file", user?.passport_num_file);
    } else if (user?.nationality?.key != "EG" && !docUploaded) {
      data.append("passport_num", user?.passport_number);
      data.append("passport_num_file", null);
    }
    data.append("first_name", user?.first_name);
    data.append("last_name", user?.last_name);
    data.append("mobile_verified_at", user?.mobile_verified_at);
    data.append("email_verified_at", user?.email_verified_at);
    const isPhoneValid = validatePhoneBeforeSubmit();

    if (isPhoneValid) {
      edit_profile(data)
        .then((res) => {
          setDocUploaded(false);
          if (res?.data?.ocr_verified?.ok == false) {
            // setIsEditMode(true);
            setLoading(false);
            // user?.nationality?.key == 'EG' ? 'national_id' : 'passport_num';
            user?.nationality?.key == "EG"
              ? setErrors({ national_id: res?.data?.ocr_verified?.message })
              : setErrors({ passport_num: res?.data?.ocr_verified?.message });
            // setErrors({ field: res?.data?.ocr_verified?.message });
            getUser()
              .then((res) => {
                const userData = res?.data?.data;
                setUser({
                  id: userData?.id,
                  profile_id: userData?.profile?.id,
                  first_name: userData?.profile?.first_name,
                  email: userData?.email,
                  phone_number: userData?.profile?.mobile,
                  country_code: userData?.profile?.country_code,
                  dial_code: userData?.profile?.dial_code,
                  nationality: {
                    key: userData?.profile?.nationality.code,
                    value: userData?.profile?.nationality.name,
                  },
                  national_id: userData?.profile?.national_id,
                  passport_number: userData?.profile?.passport_num,
                  ocr_verified: userData?.profile?.ocr_verified,
                  national_id_file: userData?.profile?.national_id_file
                    ? userData?.profile?.national_id_file[0]
                    : null,
                  passport_num_file: userData?.profile?.passport_num_file
                    ? userData?.profile?.passport_num_file[0]
                    : null,
                  birth_date: userData?.profile?.birth_date,
                  birth_place: userData?.profile?.birth_place,
                  gender: userData?.profile?.gender,
                  restOfName: userData?.profile?.restOfName,
                  last_name: userData?.profile?.last_name,
                  mobile_verified_at: userData?.profile?.mobile_verified_at,
                  email_verified_at: userData?.email_verified_at,
                });
              })
              .catch((err) => {});
            checkVerifications()
              .then((res) => {
                setVerifications(res?.data);
              })
              .catch((err) => {});
          } else if (res?.data?.otp_response?.ok == true) {
            localStorage.setItem("mobile", user?.phone_number);
            localStorage.setItem(
              "request_code",
              res?.data?.otp_response?.data?.request_code,
            );
            localStorage.setItem(
              "context",
              res?.data?.otp_response?.data?.context,
            );
            if (res?.data?.send_new_mail_verification == true) {
              const params = new URLSearchParams({
                token: res?.data?.otp_response?.data?.request_code,
                returnToEmailSentPage: true,
                email: user?.email,
                context: res?.data?.otp_response?.data?.context,
              });
              navigate(
                `/confirm-otp-profile-verification?${params.toString()}`,
                // `/confirm-otp-profile-verification?token=${encodeURIComponent(res?.data?.otp_response?.data?.request_code)}&returnToEmailSentPage=true&email=${encodeURIComponent(user?.email)}&context=${encodeURIComponent(res?.data?.data?.context)}`,
              );
            } else {
              const params = new URLSearchParams({
                token: res?.data?.otp_response?.data?.request_code,
                context: res?.data?.otp_response?.data?.context,
              });
              navigate(
                `/confirm-otp-profile-verification?${params.toString()}`,
                // `/confirm-otp-profile-verification?token=${encodeURIComponent(res?.data?.otp_response?.data?.request_code)}&context=${encodeURIComponent(res?.data?.data?.context)}`,
              );
            }
            setIsEditMode(true);
            setLoading(false);
            setSuccess(true);
          } else if (res?.data?.send_new_mail_verification == true) {
            const params = new URLSearchParams({
              email: user?.email,
            });
            navigate(
              `/mail-verify-profile?${params.toString()}`,
              // `/mail-verify-profile?email=${user?.email}`
            );
            setIsEditMode(true);
            setLoading(false);
          } else if (res?.data?.ocr_verified?.ok == true) {
            if (
              res?.data?.otp_response != null &&
              res?.data?.otp_response?.error?.reason == "hourly_limit_reached"
            ) {
              setErrors({ mobile: res?.data?.otp_response?.message });
            } else {
              setSuccess(true);
            }
            setIsEditMode(true);
            setLoading(false);
            getUser()
              .then((res) => {
                const userData = res?.data?.data;
                setUser({
                  id: userData?.id,
                  profile_id: userData?.profile?.id,
                  first_name: userData?.profile?.first_name,
                  email: userData?.email,
                  phone_number: userData?.profile?.mobile,
                  country_code: userData?.profile?.country_code,
                  dial_code: userData?.profile?.dial_code,
                  nationality: {
                    key: userData?.profile?.nationality.code,
                    value: userData?.profile?.nationality.name,
                  },
                  national_id: userData?.profile?.national_id,
                  passport_number: userData?.profile?.passport_num,
                  ocr_verified: userData?.profile?.ocr_verified,
                  national_id_file: userData?.profile?.national_id_file
                    ? userData?.profile?.national_id_file[0]
                    : null,
                  passport_num_file: userData?.profile?.passport_num_file
                    ? userData?.profile?.passport_num_file[0]
                    : null,
                  birth_date: userData?.profile?.birth_date,
                  birth_place: userData?.profile?.birth_place,
                  gender: userData?.profile?.gender,
                  restOfName: userData?.profile?.restOfName,
                  last_name: userData?.profile?.last_name,
                  mobile_verified_at: userData?.profile?.mobile_verified_at,
                  email_verified_at: userData?.email_verified_at,
                });
              })
              .catch((err) => {});
            checkVerifications()
              .then((res) => {
                setVerifications(res?.data);
              })
              .catch((err) => {});
          } else if (res?.data?.otp_response?.ok == false) {
            setErrors({ mobile: res?.data?.otp_response?.message });
            // setIsEditMode(true);
            setLoading(false);
            getUser()
              .then((res) => {
                const userData = res?.data?.data;
                setUser({
                  id: userData?.id,
                  profile_id: userData?.profile?.id,
                  first_name: userData?.profile?.first_name,
                  email: userData?.email,
                  phone_number: userData?.profile?.mobile,
                  country_code: userData?.profile?.country_code,
                  dial_code: userData?.profile?.dial_code,
                  nationality: {
                    key: userData?.profile?.nationality.code,
                    value: userData?.profile?.nationality.name,
                  },
                  national_id: userData?.profile?.national_id,
                  passport_number: userData?.profile?.passport_num,
                  ocr_verified: userData?.profile?.ocr_verified,
                  national_id_file: userData?.profile?.national_id_file
                    ? userData?.profile?.national_id_file[0]
                    : null,
                  passport_num_file: userData?.profile?.passport_num_file
                    ? userData?.profile?.passport_num_file[0]
                    : null,
                  birth_date: userData?.profile?.birth_date,
                  birth_place: userData?.profile?.birth_place,
                  gender: userData?.profile?.gender,
                  restOfName: userData?.profile?.restOfName,
                  last_name: userData?.profile?.last_name,
                  mobile_verified_at: userData?.profile?.mobile_verified_at,
                  email_verified_at: userData?.email_verified_at,
                });
              })
              .catch((err) => {});
            checkVerifications()
              .then((res) => {
                setVerifications(res?.data);
              })
              .catch((err) => {});
          } else if (
            res?.data?.send_new_mail_verification == false &&
            res?.data?.send_new_email_verification_error != null
          ) {
            setErrors({
              email: res?.data?.send_new_email_verification_error.email,
            });
            // setIsEditMode(true);
            setLoading(false);
            getUser()
              .then((res) => {
                const userData = res?.data?.data;
                setUser({
                  id: userData?.id,
                  profile_id: userData?.profile?.id,
                  first_name: userData?.profile?.first_name,
                  email: userData?.email,
                  phone_number: userData?.profile?.mobile,
                  country_code: userData?.profile?.country_code,
                  dial_code: userData?.profile?.dial_code,
                  nationality: {
                    key: userData?.profile?.nationality.code,
                    value: userData?.profile?.nationality.name,
                  },
                  national_id: userData?.profile?.national_id,
                  passport_number: userData?.profile?.passport_num,
                  ocr_verified: userData?.profile?.ocr_verified,
                  national_id_file: userData?.profile?.national_id_file
                    ? userData?.profile?.national_id_file[0]
                    : null,
                  passport_num_file: userData?.profile?.passport_num_file
                    ? userData?.profile?.passport_num_file[0]
                    : null,
                  birth_date: userData?.profile?.birth_date,
                  birth_place: userData?.profile?.birth_place,
                  gender: userData?.profile?.gender,
                  restOfName: userData?.profile?.restOfName,
                  last_name: userData?.profile?.last_name,
                  mobile_verified_at: userData?.profile?.mobile_verified_at,
                  email_verified_at: userData?.email_verified_at,
                });
              })
              .catch((err) => {});
            checkVerifications()
              .then((res) => {
                setVerifications(res?.data);
              })
              .catch((err) => {});
          } else {
            setIsEditMode(true);
            setLoading(false);
            setSuccess(true);
          }
        })
        .catch((err) => {
          setErrors(err?.response?.data?.errors);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }

  const handleRemoveDocument = (fieldName) => {
    // 1. Reset the user state keys for the specific document
    setDocUploaded(false);
    setFileDeleted(true);
    setUser((prev) => ({
      ...prev,
      [fieldName]: null,
      [`${fieldName}_url`]: null,
      [`${fieldName}_original_file_name`]: null,
      [`${fieldName}_name`]: null,
    }));

    // 2. Clear the physical input via its specific Ref
    const targetRef =
      fieldName === "national_id_file"
        ? nationalIdFileInputRef
        : passportFileInputRef;

    if (targetRef?.current) {
      targetRef.current.value = "";
    }

    // 3. Force re-render of the specific InputElement using key logic
    setInputKeys((prev) => ({
      ...prev,
      [fieldName]: (prev[fieldName] || 0) + 0.1,
    }));

    // 4. Trigger the validation error message immediately
    setError(fieldName, "يجب رفع الصورة");
  };

  return (
    <MainContent>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={styleProfile.overlay}
        className={styleProfile.content}
      >
        <div className="col-lg-8 text-center">
          <h5>{modalMessage}</h5>
          <div className="d-flex gap-4 justify-content-center mt-3">
            <button
              className="btn btn-primary px-3 "
              onClick={() => {
                navigate("/profile");
                setShowModal(false);
                setIsEditMode(false);
              }}
            >
              تعديل بيانات الحساب
            </button>
            <button
              className="btn btn-danger px-3 "
              onClick={() => setShowModal(false)}
            >
              إلغاء
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={showModalExpirationMail}
        onRequestClose={() => setShowModalExpirationMail(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={styleProfile.overlay}
        className={styleProfile.content}
      >
        <div className="col-lg-8 text-center">
          <h5>{modalMessageExpirationMail}</h5>
          <div className="d-flex gap-4 justify-content-center mt-3">
            <button
              className="btn btn-primary px-3 "
              onClick={() => {
                handleCheckEmail();
                setShowModalExpirationMail(false);
                setIsEditMode(false);
              }}
            >
              إعادة إرسال بريد التحقق من البريد الإلكتروني
            </button>
            <button
              className="btn btn-danger px-3 "
              onClick={() => {
                navigate("/profile");
                setShowModalExpirationMail(false);
                setIsEditMode(false);
              }}
            >
              العودة إلى إدارة حساب المستخدم
            </button>
          </div>
        </div>
      </Modal>
      <section className={`${styleProfile["section-content"]} section-content`}>
        <div className={`${styleProfile.container} container`}>
          <div className={`${styleProfile["card-box"]} card-box pb-5`}>
            <div className={`${styleProfile["box-content"]} box-content`}>
              <div className={`${styleProfile.box} box`}>
                <h4 className={`${styleProfile["box-title"]} box-title mb-4`}>
                  {!isEditMode
                    ? "تعديل بيانات حساب المستخدم"
                    : " إدارة حساب المستخدم"}
                </h4>
                {success && (
                  <div className="alert alert-primary" role="alert">
                    تم حفظ التعديلات بنجاح
                  </div>
                )}
                {response?.message && (
                  <div className={`alert ${response.class}`} role="alert">
                    {response.message}
                  </div>
                )}
                {errors && Object.keys(errors).length > 0 && (
                  <div className="alert alert-danger text-right" role="alert">
                    {Object.entries(errors).map(([field, message], index) =>
                      Array.isArray(message) ? (
                        message.map((msg) => (
                          <p>
                            {fieldTranslations[field] || field}: {msg}
                          </p>
                        ))
                      ) : (
                        <p>
                          {fieldTranslations[field] || field}: {message}
                        </p>
                      ),
                    )}
                  </div>
                )}

                <div className="row">
                  <div className="col-md-4">
                    <InputElement
                      allowedPattern={
                        /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                      }
                      mb4="mb-4"
                      labelHtmlFor="first_name"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="الإسم الأول"
                      inputType="text"
                      name="first_name"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="first_name"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled={
                        verifications.ocr_verified === true
                          ? true
                          : isEditMode === true
                            ? true
                            : false
                      }
                      pText={error_user.first_name}
                      value={user.first_name}
                      maxLength={24}
                      onChange={(pc, c, key, value) => {
                        handleChange("first_name", value);
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <InputElement
                      allowedPattern={
                        /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                      }
                      mb4="mb-4"
                      labelHtmlFor="restOfName"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="باقي الإسم"
                      inputType="text"
                      name="restOfName"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="restOfName"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled={
                        verifications.ocr_verified === true
                          ? true
                          : isEditMode === true
                            ? true
                            : false
                      }
                      pText={error_user.last_name}
                      value={user?.last_name}
                      maxLength={64}
                      onChange={(pc, c, key, value) => {
                        handleChange("last_name", value);
                      }}
                    />
                  </div>
                  <div className="col-md-4">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="nationality"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="الجنسية"
                      inputType="text"
                      name="nationality"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="nationality"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.nationality}
                      value={user.nationality.value}
                      maxLength={255}
                    />
                  </div>

                  {user.nationality.key === "EG" ? (
                    <Fragment>
                      {parseInt(user?.ocr_verified) !== 0 && isEditMode ? (
                        <Fragment>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="national_id"
                              labelClassName={`  ${styleProfile["form-label"]} form-label`}
                              labelText={
                                <>
                                  الرقم القومى
                                  {!response?.message && renderOcrStatus()}
                                </>
                              }
                              placeholder="ادخل الرقم القومى"
                              inputType="text"
                              name="national_id"
                              inputClassName={`${styleProfile["form-control"]} form-control`}
                              inputID="national_id"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              disabled
                              pText={error_user?.national_id}
                              value={user?.national_id}
                              profile={true}
                              profileDiv={styleProfile["form-label"]}
                              onChange={(pc, c, key, value) => {
                                handleChange("national_id", value);
                              }}
                              maxLength={14}
                              max={999999999999}
                              allowedPattern={/^[1-9]\d*$/}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              value={
                                AttachmentName(user?.national_id_file_url) ||
                                AttachmentName(
                                  user?.national_id_file_original_file_name,
                                ) ||
                                attachments[0]?.file?.original_file_name
                              }
                              disabled={isEditMode}
                              name="national_id_file"
                              mb4="mb-4"
                              labelHtmlFor="national_id_file"
                              labelClassName={` ${styleProfile["form-label"]} form-label`}
                              labelText="مرفق الرقم القومي"
                              inputType="text"
                              inputClassName={`${styleProfile["form-control"]} form-control`}
                              inputID="national_id_file_input"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              isIcon={
                                user?.national_id_file?.original_file_name ?? ""
                              }
                              idDownload={user?.profile_id}
                              filedDownload="nationalIdFile"
                            />
                          </div>
                        </Fragment>
                      ) : !isEditMode ? (
                        <Fragment>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="national_id"
                              labelClassName={`  ${styleProfile["form-label"]} form-label`}
                              labelText={
                                <>
                                  الرقم القومى
                                  {!response?.message && renderOcrStatus()}
                                </>
                              }
                              placeholder="ادخل الرقم القومى"
                              inputType="text"
                              name="national_id"
                              inputClassName={`${styleProfile["form-control"]} form-control`}
                              inputID="national_id"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              disabled={verifications.ocr_verified}
                              pText={error_user?.national_id}
                              value={user?.national_id || ""}
                              profile={true}
                              profileDiv={styleProfile["form-label"]}
                              onChange={(pc, c, key, value) => {
                                handleChange("national_id", value);
                              }}
                              maxLength={14}
                              max={999999999999}
                              allowedPattern={/^[1-9]\d*$/}
                            />
                          </div>
                          <div className="col-lg-4 col-sm-6">
                            <InputElement
                              key={inputKeys.national_id_file || 0}
                              fileInputRef={nationalIdFileInputRef}
                              mb4="mb-4"
                              inputIcon={`${styleProfile["input-icon"]} ${styleProfile["input-icon-custom"]}  input-icon`}
                              labelHtmlFor="national_id_file"
                              labelClassName={` ${styleProfile["form-label"]} required form-label`}
                              labelText="مرفق الرقم القومي"
                              inputType="file"
                              // tooltipText=" الحد الاقصي للملف 5 ميجا وصيغة الملف يجب ان تكون  PDF, JFIF, JPEG, JPG, PNG"
                              inputClassName={` ${styleProfile["form-control"]} form-control ${styleProfile["fileCustom"]}`}
                              inputID="national_id_file"
                              name="national_id_file"
                              fileName={
                                AttachmentName(user?.national_id_file_url) ||
                                AttachmentName(
                                  user?.national_id_file_original_file_name,
                                ) ||
                                attachments[0]?.file?.original_file_name ||
                                "إرفاق ملف"
                              }
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              icon="fa-solid fa-cloud-arrow-up"
                              // pText={error_new_user.national_id_file}
                              onChange={(pc, c, key, value) => {
                                handleChange("national_id_file", value);
                              }}
                              deleteFunction={() => {
                                handleRemoveDocument("national_id_file");
                              }}
                            />
                          </div>
                        </Fragment>
                      ) : (
                        parseInt(user?.ocr_verified) === 0 && (
                          <Fragment>
                            <div className="col-md-4">
                              <InputElement
                                mb4="mb-4"
                                labelHtmlFor="national_id"
                                labelClassName={`  ${styleProfile["form-label"]} form-label`}
                                labelText={
                                  <>
                                    الرقم القومى
                                    {!response?.message && renderOcrStatus()}
                                  </>
                                }
                                placeholder="ادخل الرقم القومى"
                                inputType="text"
                                name="national_id"
                                inputClassName={`${styleProfile["form-control"]} form-control`}
                                inputID="national_id"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                disabled={isEditMode}
                                pText={natianalErrorMsg}
                                value={user?.national_id}
                                profile={true}
                                profileDiv={styleProfile["form-label"]}
                                onChange={(pc, c, key, value) => {
                                  handleChange("national_id", value);
                                }}
                                maxLength={14}
                                max={999999999999}
                                allowedPattern={/^[1-9]\d*$/}
                                isButton={true}
                                buttonText="التحقق من الرقم القومي"
                                styleInputProfile={{
                                  flexShrink: "20000",
                                  borderRadius: "0 0.375rem 0.375rem 0",
                                }}
                                styleButtonProfile={{
                                  borderRadius: "0.375rem 0 0 0.375rem",
                                  height: "50px",
                                  boxShadow: "0px 3px 6px #005da838",
                                  backgroundColor: "#32a8ed",
                                  borderColor: "#32a8ed",
                                }}
                                pVerificationText={true}
                                pVerificationClass={
                                  verificationID.ok
                                    ? "text-success mb-0 mt-2 me-2 fw-bolder"
                                    : "text-danger mb-0 mt-2 me-2 fw-bolder"
                                }
                                pVerificationMessage={verificationID.message}
                                buttonOnClick={handleCheckNationalId}
                                buttonDisabled={loading}
                              />
                            </div>
                            <div className="col-md-4">
                              <InputElement
                                value={
                                  AttachmentName(user?.national_id_file_url) ||
                                  AttachmentName(
                                    user?.national_id_file_original_file_name,
                                  ) ||
                                  attachments[0]?.file?.original_file_name
                                }
                                disabled={isEditMode}
                                name="national_id_file"
                                mb4="mb-4"
                                labelHtmlFor="national_id_file"
                                labelClassName={` ${styleProfile["form-label"]} form-label`}
                                labelText="مرفق الرقم القومي"
                                inputType="text"
                                inputClassName={`${styleProfile["form-control"]} form-control`}
                                inputID="national_id_file_input"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                isIcon={
                                  user?.national_id_file?.original_file_name ??
                                  ""
                                }
                                idDownload={user?.profile_id}
                                filedDownload="nationalIdFile"
                              />
                            </div>
                          </Fragment>
                        )
                      )}
                    </Fragment>
                  ) : verifications.ocr_verified && isEditMode ? (
                    <Fragment>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="passport_number"
                          labelClassName={`  ${styleProfile["form-label"]} form-label`}
                          labelText={
                            <>
                              رقم جواز السفر
                              {!response?.message && renderOcrStatus()}
                            </>
                          }
                          placeholder="ادخل رقم جواز السفر"
                          inputType="text"
                          name="passport_number"
                          inputClassName={`${styleProfile["form-control"]} form-control`}
                          inputID="passport_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          disabled
                          pText={error_user?.passport_number}
                          value={user?.passport_number}
                          profile={true}
                          profileDiv={styleProfile["form-label"]}
                          onChange={(pc, c, key, value) => {
                            handleChange("passport_number", value);
                          }}
                          maxLength={24}
                          allowedPattern={/^[A-Za-z0-9/-]+$/}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          value={
                            AttachmentName(user?.passport_num_file_url) ||
                            AttachmentName(
                              user?.passport_num_file_original_file_name,
                            ) ||
                            attachments[0]?.file?.original_file_name
                          }
                          disabled={isEditMode}
                          name="passport_number_file"
                          mb4="mb-4"
                          labelHtmlFor="passport_number_file"
                          labelClassName={` ${styleProfile["form-label"]} form-label`}
                          labelText="مرفق جواز السفر"
                          inputType="text"
                          inputClassName={`${styleProfile["form-control"]} form-control`}
                          inputID="passport_number_file_input"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          isIcon={
                            user?.passport_num_file?.original_file_name ?? ""
                          }
                          idDownload={user?.profile_id}
                          filedDownload="passportNumFile"
                        />
                      </div>
                    </Fragment>
                  ) : !isEditMode ? (
                    <Fragment>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="passport_number"
                          labelClassName={`  ${styleProfile["form-label"]} form-label`}
                          labelText={
                            <>
                              رقم جواز السفر
                              <span className="text-danger">*</span>
                              {!response?.message && renderOcrStatus()}
                            </>
                          }
                          placeholder="ادخل رقم جواز السفر"
                          inputType="text"
                          name="passport_number"
                          inputClassName={`${styleProfile["form-control"]} form-control`}
                          inputID="passport_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          //disabled={verifications.ocr_verified}
                          pText={error_user?.passport_number}
                          value={user?.passport_number || ""}
                          profile={true}
                          profileDiv={styleProfile["form-label"]}
                          onChange={(pc, c, key, value) => {
                            handleChange("passport_number", value);
                          }}
                          maxLength={24}
                          allowedPattern={/^[A-Za-z0-9/-]+$/}
                        />
                      </div>

                      <div className="col-lg-4 col-sm-6">
                        <InputElement
                          key={inputKeys.passport_num_file || 0}
                          fileInputRef={passportFileInputRef}
                          mb4="mb-4"
                          inputIcon={`${styleProfile["input-icon"]} ${styleProfile["input-icon-custom"]}  input-icon`}
                          labelHtmlFor="passport_num_file"
                          labelClassName={` ${styleProfile["form-label"]} required form-label`}
                          labelText="مرفق جواز السفر"
                          inputType="file"
                          // tooltipText=" الحد الاقصي للملف 5 ميجا وصيغة الملف يجب ان تكون  PDF, JFIF, JPEG, JPG, PNG"
                          inputClassName={` ${styleProfile["form-control"]} form-control ${styleProfile["fileCustom"]}`}
                          inputID="passport_num_file"
                          name="passport_num_file"
                          fileName={
                            AttachmentName(user?.passport_num_file_url) ||
                            AttachmentName(
                              user?.passport_num_file_original_file_name,
                            ) ||
                            attachments[0]?.file?.original_file_name ||
                            "إرفاق ملف"
                          }
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          icon="fa-solid fa-cloud-arrow-up"
                          // pText={error_new_user.passport_num_file}
                          onChange={(pc, c, key, value) => {
                            handleChange("passport_num_file", value);
                          }}
                          deleteFunction={() =>
                            handleRemoveDocument("passport_num_file")
                          }
                        />
                      </div>
                    </Fragment>
                  ) : (
                    !verifications.ocr_verified && (
                      <Fragment>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="passport_number"
                            labelClassName={`  ${styleProfile["form-label"]} form-label`}
                            labelText={
                              <>
                                رقم جواز السفر
                                {!response?.message && renderOcrStatus()}
                              </>
                            }
                            placeholder="ادخل رقم جواز السفر"
                            inputType="text"
                            name="passport_number"
                            inputClassName={`${styleProfile["form-control"]} form-control`}
                            inputID="passport_number"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            disabled={isEditMode}
                            pText={natianalErrorMsg}
                            value={user?.passport_number}
                            profile={true}
                            profileDiv={styleProfile["form-label"]}
                            onChange={(pc, c, key, value) => {
                              handleChange("passport_number", value);
                            }}
                            maxLength={24}
                            allowedPattern={/^[1-9]\d*$/}
                            isButton={true}
                            buttonText="التحقق من رقم جواز السفر"
                            styleInputProfile={{
                              flexShrink: "20000",
                              borderRadius: "0 0.375rem 0.375rem 0",
                            }}
                            styleButtonProfile={{
                              borderRadius: "0.375rem 0 0 0.375rem",
                              height: "50px",
                              boxShadow: "0px 3px 6px #005da838",
                              backgroundColor: "#32a8ed",
                              borderColor: "#32a8ed",
                            }}
                            pVerificationText={true}
                            pVerificationClass={
                              verificationID.ok
                                ? "text-success mb-0 mt-2 me-2 fw-bolder"
                                : "text-danger mb-0 mt-2 me-2 fw-bolder"
                            }
                            pVerificationMessage={verificationID.message}
                            buttonOnClick={handleCheckNationalId}
                            buttonDisabled={loading}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            value={
                              AttachmentName(user?.passport_num_file_url) ||
                              AttachmentName(
                                user?.passport_num_file_original_file_name,
                              ) ||
                              attachments[0]?.file?.original_file_name
                            }
                            disabled={isEditMode}
                            name="passport_number_file"
                            mb4="mb-4"
                            labelHtmlFor="passport_number_file"
                            labelClassName={` ${styleProfile["form-label"]} form-label`}
                            labelText="مرفق جواز السفر"
                            inputType="text"
                            inputClassName={`${styleProfile["form-control"]} form-control`}
                            inputID="passport_number_file_input"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            isIcon={
                              user?.passport_num_file?.original_file_name ?? ""
                            }
                            idDownload={user?.profile_id}
                            filedDownload="passportNumFile"
                          />
                        </div>
                      </Fragment>
                    )
                  )}
                  <div className="col-md-4">
                    {verifications.phone_verified ? (
                      <>
                        {isEditMode ? (
                          <InputElement
                            maxLength={11}
                            allowedPattern={
                              /^0?$|^0(1(0|1|2|5)?)?$|^0(10|11|12|15)\d{0,8}$/
                            }
                            mb4="mb-4"
                            labelHtmlFor="phone_number"
                            labelClassName={`  ${styleProfile["form-label"]} form-label`}
                            labelText={
                              <>
                                رقم الهاتف المحمول
                                {!response?.message && renderMobileStatus()}
                              </>
                            }
                            placeholder="ادخل رقم الهاتف المحمول"
                            inputType="text"
                            name="phone_number"
                            inputClassName={`${styleProfile["form-control"]} form-control`}
                            inputID="phone_number"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            disabled={isEditMode}
                            pText={error_user.phone_number}
                            value={user.phone_number}
                            onChange={(pc, c, key, value) => {
                              handleChange("phone_number", value);
                            }}
                          />
                        ) : (
                          <div className="mb-4">
                            <label
                              htmlFor="mobile"
                              className={` ${styleProfile["form-label"]} form-label`}
                            >
                              <>
                                رقم الهاتف المحمول
                                <span className="text-danger">*</span>
                                {!response?.message && renderMobileStatus()}
                              </>
                            </label>

                            <PhoneInput
                              country={user?.profile?.country_code || "eg"} // default Egypt
                              preferredCountries={[
                                "eg",
                                "sa",
                                "ae",
                                "jo",
                                "kw",
                                "qa",
                                "bh",
                                "om",
                                "ma",
                              ]}
                              value={user?.phone_number}
                              onChange={(value, country, e, formattedValue) => {
                                // If the selected country changed, reset phone_number
                                if (
                                  country?.countryCode !== user?.country_code
                                ) {
                                  value = country?.dialCode;
                                }

                                const nationalNumber = value
                                  ?.replace(country?.dialCode, "")
                                  ?.replace(/\D/g, "");
                                // ✅ Egypt-specific normalization: remove extra leading 0
                                if (
                                  country?.countryCode === "eg" &&
                                  nationalNumber?.startsWith("0")
                                ) {
                                  value =
                                    country?.dialCode +
                                    nationalNumber?.slice(1);
                                }

                                // ✅ Length validation, but don’t wipe the value
                                if (
                                  (nationalNumber?.length < 6 ||
                                    nationalNumber?.length > 15) &&
                                  value !== country?.dialCode
                                ) {
                                  setPhoneError(
                                    "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
                                  );
                                  // keep the current value instead of returning
                                  handleChange("phone_number", value);
                                } else {
                                  setPhoneError(null);
                                  handleChange("phone_number", value);
                                }

                                handleChange("phone_number", value);
                                handleChange(
                                  "country_code",
                                  country?.countryCode,
                                );
                                handleChange("dial_code", country?.dialCode);
                              }}
                              inputProps={{
                                name: "phone_number",
                                id: "phone_number",
                                required: true,
                                className: "phone-control form-control",
                                placeholder: "",
                              }}
                              containerClass="w-100"
                              inputClass="w-100"
                              dropdownClass="custom-dropdown"
                              enableAreaCodes={false}
                              countryCodeEditable={false}
                              enableSearch={true}
                            />

                            {(phoneError || error_user.phone_number) && (
                              <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                                {phoneError || error_user.phone_number}
                              </p>
                            )}
                          </div>
                        )}
                      </>
                    ) : !verifications.phone_verified && isEditMode ? (
                      <InputElement
                        maxLength={11}
                        allowedPattern={
                          /^0?$|^0(1(0|1|2|5)?)?$|^0(10|11|12|15)\d{0,8}$/
                        }
                        mb4="mb-4"
                        labelHtmlFor="phone_number"
                        labelClassName={`  ${styleProfile["form-label"]} form-label`}
                        labelText={
                          <>
                            رقم الهاتف المحمول
                            {!response?.message && renderMobileStatus()}
                          </>
                        }
                        placeholder="ادخل رقم الهاتف المحمول"
                        inputType="text"
                        name="phone_number"
                        inputClassName={`${styleProfile["form-control"]} form-control`}
                        inputID="phone_number"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        disabled={isEditMode}
                        pText={errMessagePhone}
                        value={user.phone_number}
                        onChange={(pc, c, key, value) => {
                          handleChange("phone_number", value);
                        }}
                        isButton={true}
                        buttonText="التحقق من رقم الهاتف"
                        profile={true}
                        profileDiv={styleProfile["form-label"]}
                        styleInputProfile={{
                          flexShrink: 20000,
                          borderRadius: "0 0.375rem 0.375rem 0",
                        }}
                        styleButtonProfile={{
                          borderRadius: "0.375rem 0 0 0.375rem",
                          height: "50px",
                          boxShadow: "0px 3px 6px #005da838",
                          backgroundColor: "#32a8ed",
                          borderColor: "#32a8ed",
                          pointerEvents: user?.country_code !== "eg" && "none",
                          textDecoration: user?.country_code !== "eg" && "none",
                          opacity: user?.country_code !== "eg" && ".5",
                        }}
                        pVerificationTex={true}
                        pVerificationClass={
                          verificationPhoneNumber.ok
                            ? "text-success mb-0 mt-2 me-2 fw-bolder"
                            : "text-danger mb-0 mt-2 me-2 fw-bolder"
                        }
                        pVerificationMessage={verificationPhoneNumber.message}
                        buttonOnClick={handleCheckPhoneNumber}
                        buttonDisabled={loading}
                      />
                    ) : (
                      !isEditMode && (
                        // <InputElement
                        //   maxLength={11}
                        //   allowedPattern={
                        //     /^0?$|^0(1(0|1|2|5)?)?$|^0(10|11|12|15)\d{0,8}$/
                        //   }
                        //   mb4="mb-4"
                        //   labelHtmlFor="phone_number"
                        //   labelClassName={`  ${styleProfile["form-label"]} form-label`}
                        //   labelText="رقم الهاتف المحمول"
                        //   inputType="text"
                        //   name="phone_number"
                        //   inputClassName={`${styleProfile["form-control"]} form-control`}
                        //   inputID="phone_number"
                        //   pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        //   disabled={isEditMode}
                        //   pText={errMessagePhone}
                        //   value={user.phone_number}
                        //   onChange={(pc, c, key, value) => {
                        //     handleChange("phone_number", value);
                        //   }}
                        // />
                        <div className="mb-4">
                          <label
                            htmlFor="phone_number"
                            className={` ${styleProfile["form-label"]} form-label`}
                          >
                            <>
                              رقم الهاتف المحمول
                              <span className="text-danger">*</span>
                              {!response?.message && renderMobileStatus()}
                            </>
                          </label>

                          <PhoneInput
                            country={user?.profile?.country_code || "eg"} // default Egypt
                            preferredCountries={[
                              "eg",
                              "sa",
                              "ae",
                              "jo",
                              "kw",
                              "qa",
                              "bh",
                              "om",
                              "ma",
                            ]}
                            value={user?.phone_number}
                            onChange={(value, country, e, formattedValue) => {
                              // If the selected country changed, reset phone_number
                              if (country?.countryCode !== user?.country_code) {
                                value = country?.dialCode;
                              }

                              const nationalNumber = value
                                ?.replace(country?.dialCode, "")
                                ?.replace(/\D/g, "");
                              // ✅ Egypt-specific normalization: remove extra leading 0
                              if (
                                country?.countryCode === "eg" &&
                                nationalNumber?.startsWith("0")
                              ) {
                                value =
                                  country?.dialCode + nationalNumber?.slice(1);
                              }

                              // ✅ Length validation, but don’t wipe the value
                              if (
                                (nationalNumber?.length < 6 ||
                                  nationalNumber?.length > 15) &&
                                value !== country?.dialCode
                              ) {
                                setPhoneError(
                                  "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
                                );
                                // keep the current value instead of returning
                                handleChange("phone_number", value);
                              } else {
                                setPhoneError(null);
                                handleChange("phone_number", value);
                              }

                              handleChange("phone_number", value);
                              handleChange(
                                "country_code",
                                country?.countryCode,
                              );
                              handleChange("dial_code", country?.dialCode);
                            }}
                            inputProps={{
                              name: "phone_number",
                              id: "phone_number",
                              required: true,
                              className: "phone-control form-control",
                              placeholder: "",
                            }}
                            containerClass="w-100"
                            inputClass="w-100"
                            dropdownClass="custom-dropdown"
                            enableAreaCodes={false}
                            enableSearch={true}
                            countryCodeEditable={false}
                          />

                          {(phoneError || error_user.phone_number) && (
                            <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                              {phoneError || error_user.phone_number}
                            </p>
                          )}
                        </div>
                      )
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="birth_date"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="تاريخ الميلاد"
                      inputType="text"
                      name="birth_date"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="birth_date"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.birth_date}
                      value={user.birth_date}
                      maxLength={255}
                    />
                  </div>
                  <div className="col-md-4">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="birth_place"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="محل الميلاد"
                      inputType="text"
                      name="birth_place"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="birth_place"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.birth_place}
                      value={user.birth_place}
                      maxLength={255}
                    />
                  </div>
                  <div className="col-md-4">
                    <InputElement
                      mb4="mb-4"
                      labelHtmlFor="gender"
                      labelClassName={`  ${styleProfile["form-label"]} form-label`}
                      labelText="النوع"
                      inputType="text"
                      name="gender"
                      inputClassName={`${styleProfile["form-control"]} form-control`}
                      inputID="gender"
                      pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                      disabled
                      pText={error_user.gender}
                      value={user.gender}
                      maxLength={255}
                    />
                  </div>

                  <div className="col-md-4">
                    {verifications.email_verified ||
                    response?.status == 200 ||
                    user.email == null ? (
                      <InputElement
                        allowedPattern={/^[A-Za-z0-9._@-]{1,100}$/}
                        mb4="mb-4"
                        labelHtmlFor="email"
                        labelClassName={`${styleProfile["form-label"]} form-label`}
                        labelText={
                          <>
                            البريد الإلكترونى
                            {!isEditMode && user?.country_code !== "eg" && (
                              <span className="text-danger">*</span>
                            )}
                            {!response?.message && renderEmailStatus()}
                          </>
                        }
                        placeholder=" ادخل البريد الإلكترونى"
                        inputType="text"
                        name="email"
                        inputClassName={`${styleProfile["form-control"]} form-control`}
                        inputID="email"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        disabled={isEditMode}
                        pText={error_user.email}
                        value={user.email || ""}
                        onChange={(pc, c, key, value) => {
                          handleChange("email", value);
                        }}
                      />
                    ) : !verifications.email_verified && isEditMode ? (
                      <InputElement
                        allowedPattern={/^[A-Za-z0-9._@-]{1,100}$/}
                        mb4="mb-4"
                        labelHtmlFor="email"
                        labelClassName={`${styleProfile["form-label"]} form-label`}
                        labelText={
                          <>
                            البريد الإلكترونى
                            {!response?.message && renderEmailStatus()}
                          </>
                        }
                        placeholder=" ادخل البريد الإلكترونى"
                        inputType="text"
                        name="email"
                        inputClassName={`${styleProfile["form-control"]} form-control`}
                        inputID="email"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        disabled={isEditMode}
                        pText={errMessageEmail}
                        value={user.email || ""}
                        maxLength={255}
                        isButton={true}
                        buttonText="التحقق من البريد الإلكترونى"
                        profile={true}
                        profileDiv={styleProfile["form-label"]}
                        styleInputProfile={{
                          flexShrink: 20000,
                          borderRadius: "0 0.375rem 0.375rem 0",
                        }}
                        styleButtonProfile={{
                          borderRadius: "0.375rem 0 0 0.375rem",
                          height: "50px",
                          boxShadow: "0px 3px 6px #005da838",
                          backgroundColor: "#32a8ed",
                          borderColor: "#32a8ed",
                        }}
                        pVerificationText={true}
                        pVerificationClass={
                          verificationEmail.ok
                            ? "text-success mb-0 mt-2 me-2 fw-bolder"
                            : "text-danger mb-0 mt-2 me-2 fw-bolder"
                        }
                        pVerificationMessage={verificationEmail.message}
                        buttonOnClick={handleCheckEmail}
                        onChange={(pc, c, key, value) => {
                          handleChange("email", value);
                        }}
                        buttonDisabled={loading}
                      />
                    ) : (
                      !isEditMode && (
                        <InputElement
                          allowedPattern={/^[A-Za-z0-9._@-]{1,100}$/}
                          mb4="mb-4"
                          labelHtmlFor="email"
                          labelClassName={`${styleProfile["form-label"]} form-label`}
                          labelText={
                            <>
                              البريد الإلكترونى
                              {!response?.message && renderEmailStatus()}
                            </>
                          }
                          placeholder=" ادخل البريد الإلكترونى"
                          inputType="text"
                          name="email"
                          inputClassName={`${styleProfile["form-control"]} form-control`}
                          inputID="email"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          disabled={isEditMode}
                          pText={errMessageEmail}
                          value={user.email || ""}
                          maxLength={255}
                          onChange={(pc, c, key, value) => {
                            handleChange("email", value);
                          }}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>

              {!isEditMode ? (
                <div
                  className={`${styleProfile.btnMyProfile} d-flex justify-content-start flex-md-row flex-column align-items-center mt-4 gap-lg-5  gap-3`}
                >
                  <button
                    onClick={updateProfile}
                    className={styleProfile["btn-edit"]}
                    disabled={loading}
                  >
                    حفظ التعديلات
                  </button>
                  <button
                    onClick={() => {
                      setIsEditMode(true);
                      setErrors(false);
                      setResponse("");
                      setLoading(false);
                    }}
                    className={styleProfile["btn-cancle"]}
                  >
                    إلغاء
                  </button>
                </div>
              ) : (
                <div
                  className={`${styleProfile.btnMyProfile} d-flex justify-content-start flex-md-row flex-column align-items-center mt-4 gap-lg-5 gap-3`}
                >
                  {" "}
                  <button
                    onClick={changeProfile}
                    className={styleProfile["btn-edit"]}
                    disabled={loading}
                  >
                    تعديل بيانات حساب المستخدم
                  </button>
                  <Link
                    to="/set-password"
                    className={styleProfile["btn-cancle"]}
                  >
                    تغيير كلمة المرور
                  </Link>
                  <Link
                    to="/user-settings"
                    className={styleProfile["btn-cancle"]}
                  >
                    العودة إلى إدارة المستخدم
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default Profile;
